import React, { useState } from "react";
import StepShell from "./StepShell";
import copy from "../copy";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailStep = ({ data, handleChange, onNext, onBack }) => {
  const [email, setEmail] = useState(data.email || "");
  const [touched, setTouched] = useState(false);

  const valid = EMAIL_RE.test(email.trim());

  const onChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    // Only a valid address is stored.
    handleChange("email", EMAIL_RE.test(value.trim()) ? value.trim() : "");
  };

  const showError = touched && email.trim() !== "" && !valid;

  return (
    <StepShell title={copy.email.title} subtitle={copy.email.text} onBack={onBack}>
      <form
        className="rp-form"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) onNext();
        }}
      >
        <input
          className="rp-input"
          type="email"
          name="email"
          inputMode="email"
          autoComplete="email"
          placeholder={copy.email.placeholder}
          aria-label={copy.email.placeholder}
          aria-invalid={showError}
          value={email}
          onChange={onChange}
          onBlur={() => setTouched(true)}
        />
        {showError && <p className="rp-error">{copy.email.invalid}</p>}
        <div className="rp-actions">
          <button type="submit" className="rp-btn" disabled={!valid}>
            {copy.next}
          </button>
        </div>
      </form>
    </StepShell>
  );
};

export default EmailStep;
